$.fn.appendEach = (arrayOfWrappers) ->
	rawArray = $.map arrayOfWrappers, (value, index) ->
		return value.get()

	@append rawArray
	return @

$.fn.serializeObject = ->
	o = {}
	a = @.serializeArray()
	$.each a, ->
		value = @.value
		name = @.name
		if o[name]?
			o[name] = [o[name]] if !o[name].push
			o[name].push(value || '')
		else
			o[name] = value || ''
	return o

$.fn.outerHTML = (s) ->
	if s then @before(s).remove() else $("<p>").append(@eq(0).clone()).html()

window.sortObject = (object, order) ->
	sortedObject = {}
	keys = Object.keys object

	keys = _.sortBy keys, (key) ->
		if order.indexOf key >= 0 then order.indexOf key else 0

	for key in keys
		sortedObject[key] = object[key]

	sortedObject


/** WEBPACK FOOTER **
 ** ./assets/coffee/helpers.coffee
 **/